import { useEffect, useState } from 'react'
import { KpiCard } from '@/components/ui/Card'
import { DollarSign, Clock, CheckCircle, TrendingUp } from 'lucide-react'
import api from '@/services/api'

interface SummaryData {
  pendentes: { total: number; count: number }
  pagas: { total: number; count: number }
  estornadas: { total: number; count: number }
}

function formatCurrency(cents: number) {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(cents / 100)
}

interface ComissoesDashboardProps {
  period?: string
}

export function ComissoesDashboard({ period }: ComissoesDashboardProps) {
  const [data, setData] = useState<SummaryData | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(true)
    const params = period ? `?period=${period}` : ''
    api.get(`/commissions/summary${params}`)
      .then((res) => setData(res.data.data))
      .catch(() => {})
      .finally(() => setLoading(false))
  }, [period])

  if (loading || !data) {
    return (
      <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4'>
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className='glass-card p-5 animate-pulse h-28' />
        ))}
      </div>
    )
  }

  const totalGeral = data.pendentes.total + data.pagas.total

  return (
    <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4'>
      <KpiCard
        label='A Receber'
        value={formatCurrency(data.pendentes.total)}
        change={`${data.pendentes.count} pendente${data.pendentes.count !== 1 ? 's' : ''}`}
        changePositive={false}
        icon={<Clock size={18} />}
      />
      <KpiCard
        label='Recebido'
        value={formatCurrency(data.pagas.total)}
        change={`${data.pagas.count} paga${data.pagas.count !== 1 ? 's' : ''}`}
        changePositive
        icon={<CheckCircle size={18} />}
      />
      <KpiCard
        label='Estornadas'
        value={formatCurrency(data.estornadas.total)}
        change={`${data.estornadas.count} estornada${data.estornadas.count !== 1 ? 's' : ''}`}
        changePositive={false}
        icon={<DollarSign size={18} />}
      />
      <KpiCard
        label='Total Geral'
        value={formatCurrency(totalGeral)}
        change='pendente + recebido'
        changePositive
        icon={<TrendingUp size={18} />}
      />
    </div>
  )
}
